import http from '@/common/request/axios';

export default {
    list({ offset, limit, store }: any) {
        return http.doGet('admin/version', { offset, limit, store });
    },

    create(store: any, version: any, assetLink: any, releasedDate: any) {
        return http.doPost('admin/version', {
            store: store,
            version: version,
            assetLink: assetLink,
            releasedDate: releasedDate
        });
    },

    update(id: any, assetLink: any, releasedDate: any) {
        return http.doPut('admin/version/' + id, {
            assetLink: assetLink,
            releasedDate: releasedDate
        });
    },

    get(id: any) {
        return http.doGet('admin/version/' + id);
    },

    remove(id: any) {
        return http.doDelete('admin/version/' + id);
    },

    activate(id: any) {
        return http.doPut('admin/version/' + id + '/activate');
    },

    drop(id: any) {
        return http.doPut('admin/version/' + id + '/drop');
    },

    undrop(id: any) {
        return http.doPut('admin/version/' + id + '/undrop');
    }
};
